import { createAction } from "@reduxjs/toolkit"

export const fetchApiHealth = createAction("FETCH_API_HEALTH_SAGA")